var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gofix-card',{staticClass:"cardTable chartOfAccount",attrs:{"fullContent":""}},[_c('iframe',{ref:"iframepreview",attrs:{"id":"iframepreview","src":_vm.ifsrc,"width":"100%","height":"1000px"},on:{"load":_vm.load}})])}
var staticRenderFns = []

export { render, staticRenderFns }